import { NewFeedPictureModel } from "../../newfeeds/models/NewFeedModel";
import { CollageLayoutManager, PhotoCollageStyle, PhotoSize } from "../models/PhotoCollageModel";
import { CollageProps } from "./TwoPhotoView";

export default function TwoPhotoView({ photos, photoManager, layout }: CollageProps) {
    const layoutManager = new CollageLayoutManager(layout);

    const style = new PhotoCollageStyle(
        photoManager.dimension.getSpacing(),
        layoutManager.isTall()
    );

    const large = (photo: NewFeedPictureModel): JSX.Element => {
        return <>
            {photoManager.getRectangle(
                photo,
                layoutManager.isHalf() ? PhotoSize.half : PhotoSize.twoThird,
                PhotoSize.full,
                layoutManager.isTall()
            )}
        </>;
    }

    const small = (photo: NewFeedPictureModel): JSX.Element => {
        return <>
            {photoManager.getRectangle(
                photo,
                layoutManager.isHalf() ? PhotoSize.half : PhotoSize.oneThird,
                PhotoSize.half,
                layoutManager.isTall()
            )}
        </>;
    }

    const smallStyle: React.CSSProperties = {
        display: style.innerDisplay,
        paddingBottom: style.paddingBottom,
        paddingRight: style.paddingRight
    };

    return <div style={{ display: "inline-block" }}>
        <div style={{
            float: style.outerFloat,
            paddingRight: style.paddingBottom,
            paddingBottom: style.paddingRight
        }}>
            {large(photos[0])}
        </div>
        <div style={{ float: style.innerFloat }}>
            <div style={smallStyle}>{small(photos[1])}</div>
            <div style={smallStyle}>{small(photos[2])}</div>
        </div>
    </div>;
}